export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST';

export const updateOrderRequest = ( id: string, updateData: Record<string, unknown> ) => ({
    type: UPDATE_ORDER_REQUEST,
    payload: { id, updateData }
});
